import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { ENPOINT } from "../endpoint";

import { Options } from 'selenium-webdriver/safari';
import { StorageService } from "../../services/storage.service";
@Injectable()
export class AsistenteService {
 
	constructor(
		private http: HttpClient,
		private storageService: StorageService) { }

  	private basePath = ENPOINT.urlAsistente;
  	private len = ENPOINT.len;
  	private client = ENPOINT.client;


  	getSolution( errorCode : number ): Observable<any> 
  	{
  		let user = this.storageService.getCurrentUser();
  		//let email = user.email;  
	    let email= "miguelacosta@glouu.com"
	    let request;
	    let httpHeaders = new HttpHeaders()
	    .set('Content-Type', 'application/json')
	    let options = {
	      headers: httpHeaders
	        }
	    return  request = this.http.get(this.basePath + 'buscarSolucion/'+errorCode+'&'+this.client+'&'+email+'&'+this.len, options)
	      .pipe(
	        retry(3)// retry a failed request up to 3 times
	        // then handle the error
	      );
  	}

}


// WEBPACK FOOTER //
// ./src/app/services/assistant/asistente.service.ts